// extracted by mini-css-extract-plugin
module.exports = {"column":"rates_table_header_column_column__2GOej","columnContent":"rates_table_header_column_columnContent__OUNLG","columnLabel":"rates_table_header_column_columnLabel__1I34a"};